import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["mode", "teams", "people", "workStreams"]

  connect() {
    this.update()
  }

  update() {
    const mode = this.modeTarget.value
    this.toggle(this.teamsTarget, mode === "selected_teams")
    this.toggle(this.peopleTarget, mode === "selected_people")
    this.toggle(this.workStreamsTarget, mode === "selected_work_streams")
  }

  toggle(element, visible) {
    element.classList.toggle("hidden", !visible)
    element.hidden = !visible
  }
}
